<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<div class="list-loader" *ngIf="loading$ | async">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em *ngIf="loading$ | async">Loading jobs...</em>
			<em *ngIf="!(loading$ | async)">No associated customers</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="companyName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let customer">
			<a [routerLink]="customersFragments.detail(customer.id)">
				{{ customer.companyName }}
			</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="employerIdentificationNumber">
		<th mat-header-cell *matHeaderCellDef>Tax ID</th>
		<td mat-cell *matCellDef="let customer">
			{{ customer.employerIdentificationNumber }}
		</td>
	</ng-container>

	<ng-container matColumnDef="billingEmail">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Billing Email</th>
		<td mat-cell *matCellDef="let customer">
			{{ customer.billingEmail }}
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.data.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.data.length > 0"
	></tr>
	<tr mat-row *matRowDef="let customer; columns: resultColumns"></tr>
</table>

<div fxLayout fxLayoutAlign="space-between center">
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
	></mat-paginator>
</div>
